/** @format */

import request from '@edgeguideab/client-request';
import config from 'config.json';
import history from 'utils/history';
import checkSession from './check';

export default function switchUser(value) {
  return async (dispatch) => {
    dispatch({ type: 'SESSION_SWITCH_USER_START' });
    history.push('/home');
    let response;
    const requestUrl = `${config.apiServer}/sessions/switchUser`;
    try {
      response = await request.post(requestUrl, {
        body: { id: value }
      });
    } catch (errorResponse) {
      return dispatch({
        type: 'SESSION_SWITCH_USER_FAILED',
        payload: {
          msg: errorResponse.body.msg || 'errors.maintenance'
        }
      });
    }

    window.localStorage.setItem('csrfToken', response.body.csrfToken);
    dispatch({
      type: 'SESSION_SWITCH_USER_DONE',
      payload: response.body
    });

    dispatch(checkSession({ successRedirect: true }));
  };
}
